import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import { AuthContext } from '../context/AuthContext';

// Pantalla de bloqueo que se muestra cuando no hay caja abierta
export const PantallaCajaCerrada = ({ modulo = 'al Punto de Venta' }) => {
    const navigate = useNavigate();

    return (
        <div style={{
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'var(--sidebar-bg)',
            padding: '2rem',
            textAlign: 'center'
        }}>
            <i className="bi bi-lock-fill" style={{ fontSize: '5rem', color: '#dc2626', marginBottom: '1rem' }}></i>
            <h2 style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#111827', marginBottom: '1rem' }}>Caja Cerrada</h2>
            <p style={{ fontSize: '1.25rem', color: '#4b5563', marginBottom: '2.5rem', maxWidth: '600px', lineHeight: '1.5' }}>
                Debes abrir la caja registradora antes de poder acceder {modulo} y realizar ventas.
            </p>
            <button
                onClick={() => navigate('/fast-food/shift')}
                style={{
                    padding: '1rem 2.5rem',
                    backgroundColor: 'var(--primary-color)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '1.25rem',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                    transition: 'transform 0.2s',
                }}
                onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
            >
                Ir a Abrir Caja
            </button>
        </div>
    );
};

// Bloquea el módulo hijo mientras no haya un turno de caja abierto.
// Misma regla que el POS: caja normal abierta (cualquier usuario) o caja de
// ferias abierta (solo Admin / Cocinero).
const RequiereCajaAbierta = ({ children, modulo }) => {
    const { user } = useContext(AuthContext);
    const roleName = user?.role_details?.name;
    const isAdmin = roleName === 'SUPER_ADMIN' || user?.is_superuser || roleName === 'ADMIN_FAST_FOOD' || user?.role === 'admin';
    const isCook = roleName === 'COOK' || user?.role === 'COOK' || user?.role_details?.description?.toLowerCase()?.includes('cocinero');
    const canAccessFeria = isAdmin || isCook;

    const [checking, setChecking] = useState(true);
    const [cajaAbierta, setCajaAbierta] = useState(false);

    useEffect(() => {
        let isMounted = true;

        const extractOpenShift = (res) => {
            if (res.status !== 'fulfilled' || !res.value?.data) return null;
            const data = res.value.data;
            if (data.shift && data.shift.id && data.shift.status === 'open') return data.shift;
            if (data.id && data.status === 'open') return data;
            return null;
        };

        const checkShift = async () => {
            const [localRes, feriaRes] = await Promise.allSettled([
                api.get('/api/pos/shifts/current/', {
                    baseURL: process.env.REACT_APP_FAST_FOOD_SERVICE,
                    params: { is_feria: false }
                }),
                api.get('/api/pos/shifts/current/', {
                    baseURL: process.env.REACT_APP_FAST_FOOD_SERVICE,
                    params: { is_feria: true }
                })
            ]);

            if (!isMounted) return;
            const localShift = extractOpenShift(localRes);
            const feriaShift = canAccessFeria ? extractOpenShift(feriaRes) : null;
            setCajaAbierta(Boolean(localShift || feriaShift));
            setChecking(false);
        };

        checkShift();
        return () => { isMounted = false; };
    }, [canAccessFeria]);

    if (checking) return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            fontSize: '1.125rem',
            color: '#6b7280'
        }}>
            Verificando estado de caja...
        </div>
    );

    if (!cajaAbierta) return <PantallaCajaCerrada modulo={modulo} />;

    return children;
};

export default RequiereCajaAbierta;
